import { useState, useEffect } from 'react';

import Home from './Home';
import NotFound from './NotFound';
import Projects from './Projects';
import Team from './Team';
import Contact from './Contact';
import LegalNotice from './LegalNotice';

import Project from './projects/Project';

import MobileApps from './skills/MobileApps';
import Graphics from './skills/Graphics';
import BackEnd from './skills/BackEnd';
import ProjectManagement from './skills/ProjectManagement';

import ProjectQuery from './model/Projects';
import { getLocaleFromPath } from './i18n/locales';
import { internalPathFor } from './i18n/routes';

const notFound = {
  status: 404,
  pageBuilder: (route) => <NotFound route={route} />
};

const router = {
  "/": {
    style: "dark",
    pageBuilder: (route) => <Home route={route} />
  },
  "/expertises": {
    "/apps-mobiles": {
      pageBuilder: (route) => <MobileApps route={route} />
    },
    "/back-end": {
      pageBuilder: (route) => <BackEnd route={route} />
    },
    "/developpement-3d": {
      pageBuilder: (route) => <Graphics route={route} />
    },
    "/gestion-de-projet": {
      pageBuilder: (route) => <ProjectManagement route={route} />
    },
  },
  "/realisations": {
    "/": {
      pageBuilder: (route) => <Projects route={route} />
    },
    ... ProjectQuery().reduce((acc, project) => {
      acc[`/${project.slug}`] = {
        pageBuilder: (route) => <Project route={route} project={project} />
      };
      return acc;
    }, {})
  },
  "/equipe": {
    pageBuilder: (route) => <Team route={route} />
  },
  "/contact": {
    pageBuilder: (route) => <Contact route={route} />
  },
  "/mentions-legales": {
    pageBuilder: (route) => <LegalNotice route={route} />
  }
};

function getRoute(router, path) {
  const index = path.indexOf('/', 1);
  
  const route = index === -1 ? path : path.substring(0, index);
  router = router[route];

  if (typeof router !== 'object') {
    return notFound;
  }

  path = index === -1 ? '/' : path.substring(index);
  if (router.pageBuilder === undefined) {
    return getRoute(router, path);
  }

  return (path === '/') ? router : getRoute(router, path);
};

function Router({path, onRouteChanged}) {
  const internalPath = internalPathFor(path);
  const route = getRoute(router, internalPath);
  
  route.status = route.status ?? 200;
  route.style = route.style ?? "light";
  route.drawer = useState(false);
  route.locale = getLocaleFromPath(path);
  route.path = internalPath;
  route.localizedPath = path;

  useEffect(() => {
    const event = new Event('AppRouteChanged');
    window.dispatchEvent(event);
  }, [route.drawer[0]]);
  
  if (onRouteChanged) {
    onRouteChanged(route);
  }

  return route.pageBuilder(route);
}

export default Router;
